<script>
    import { onMount } from "svelte";
    import { getPasswordValidation } from "../../Utils/utilFunctions.svelte";

    let showPassword = false;

    export let value = "",
        isConfirm = false,
        isRequired = false,
        onInput = () => {};

    export let pwdValue = "";

    $: showHelperText = !isConfirm && value && !isPwdValid;

    $: isPwdMatched = pwdValue && value ? pwdValue === value : true;

    $: showPwdNotMatchedText = isConfirm && isConfirmPwdValid && !isPwdMatched;

    // $: isPwdLengthValid = value && value.length >= 8;
    // $: hasUppercase = value && /[A-Z]/.test(value);
    // $: hasLowercase = value && /[a-z]/.test(value);
    // $: hasNumber = value && /[0-9]/.test(value);
    // $: hasSymbol = value && /\W/.test(value);
    $: isPwdValid = value && getPasswordValidation(value);

    // Show NOT MATCH error text on confirm input
    $: isConfirmPwdValid = pwdValue && getPasswordValidation(pwdValue);

    $: if (!showHelperText) _resetInputStyle();
    else _setInputError();

    onMount(() => {
        _preventCopyAndPaste();
    });

    const toggleShowPassword = () => {
        showPassword = !showPassword;
        keepShowPasswordStatus();
    };

    const keepShowPasswordStatus = () => {
        let el = isConfirm
            ? document.getElementById("confirmPassword")
            : document.getElementById("password");
        if (showPassword) el.type = "text";
        else el.type = "password";
    };

    // HELPER FUNCTIONS
    const _preventCopyAndPaste = () => {
        const inputField = document.getElementById(
            isConfirm ? "confirmPassword" : "password",
        );

        if (inputField) {
            inputField.addEventListener("copy", (e) => {
                e.preventDefault();
            });
            inputField.addEventListener("paste", (e) => {
                e.preventDefault();
            });
        }
    };

    const _setInputError = () => {
        if (isConfirm) return;

        const field = document.getElementById("password");
        if (field) field.style.outline = "red solid 2px";
    };

    const _resetInputStyle = () => {
        if (isConfirm) return;

        const field = document.getElementById("password");
        if (field) field.style.outline = "none";
    };
</script>

<div class="flex flex-col flex-1 gap-y-1">
    <div class="flex flex-1 relative">
        <input
            type="password"
            bind:value
            required={isRequired}
            class="input input-bordered input-sm flex flex-1"
            id={isConfirm ? "confirmPassword" : "password"}
            on:focus={_resetInputStyle}
            on:input={onInput}
        />

        {#if showPassword}
            <i
                style="font-size:16px"
                class="fa absolute top-1/3 right-4 hover:cursor-pointer"
                on:click|preventDefault={toggleShowPassword}>&#xf070;</i
            >
        {:else}
            <i
                style="font-size:16px"
                class="fa absolute top-1/3 right-4 hover:cursor-pointer"
                on:click|preventDefault={toggleShowPassword}>&#xf06e;</i
            >
        {/if}
    </div>

    {#if showHelperText}
        <div class="flex flex-col flex-1 gap-y-1">
            <p class="text-error text-xs">
                Password must be at least 8 characters long and include
                uppercase letters, lowercase letters, numbers and symbols.
            </p>

            <!-- <li
                class={`${isPwdLengthValid ? "checkMark text-secondary" : "crossMark text-error"}`}
            >
                Password length no less than 8 characters.
            </li>
            <li
                class={`${hasUppercase ? "checkMark text-secondary" : "crossMark text-error"}`}
            >
                Password contains upper case characters.
            </li>
            <li
                class={`${hasLowercase ? "checkMark text-secondary" : "crossMark text-error"}`}
            >
                Password contains lower case characters.
            </li>
            <li
                class={`${hasNumber ? "checkMark text-secondary" : "crossMark text-error"}`}
            >
                Password contains numbers.
            </li>
            <li
                class={`${hasSymbol ? "checkMark text-secondary" : "crossMark text-error"}`}
            >
                Password contains special symbols.
            </li> -->
        </div>
    {/if}

    {#if showPwdNotMatchedText}
        <div class="flex flex-col flex-1 gap-y-1">
            <p class="text-error text-xs">Passwords do not match.</p>
        </div>
    {/if}
</div>

<style>
    li {
        font-size: 16px;
        list-style-type: none;
        padding: 0;
    }

    li.checkMark::before {
        content: "✓";
        margin-right: 8px;
    }

    li.crossMark::before {
        content: "✗";
        margin-right: 8px;
    }
</style>
